module.exports = __webpack_public_path__ + "static/img/icon-WST.2b2170a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-WST.svg
// module id = CSxR
// module chunks = 0